<template>
  <router-view></router-view>
</template>

<script>
  import tenantApi from "../api/tenant";
  export default {
    props: {
      tenantId: {
        type: String,
      },
    },
    methods: {
      async reloadTenant() {
        const tenant = await tenantApi.getCurrentTenant();
        this.$store.commit('setTenant', tenant);
      },
    },
    created() {
      tenantApi.setSelectedTenant(this.tenantId);
      this.reloadTenant();
    },
  }
</script>

<style scoped>

</style>
